<template>
  <div>
    <player />
    <header class="page-container">
      <b-navbar toggleable="lg" type="light" variant="default" class="pl-0">
        <router-link to="/" exact class>
          <b-navbar-brand class="mr-5">
            <b-img :src="isRTL ? '/static/hadaf-mobile.png' : '/static/logo_mobile_new.png'" class="d-block d-lg-none img-fluid" :alt="$_t('KW:site.title')" />
            <b-img
              :src="isRTL ? '/static/hadaf-logo.svg' : '/static/logo.png'"
              :alt="$_t('KW:site.title')"
              class="d-none d-lg-block"
              :class="isRTL ? '' : 'rounded-circle shadow'"
            />
          </b-navbar-brand>
        </router-link>
        <b-btn @click="showCollapse = !showCollapse" variant="none" class="d-block d-lg-none btn-lg bg-dark-blue text-white">
          <i class="fa fa-fw" :class="showCollapse ? 'fa-times ' : 'fa-bars'"></i>
        </b-btn>
        <b-collapse id="collapse-menu" class="row navbar-collapse" v-model="showCollapse">
          <b-navbar-nav class="main justify-content-between text-center float-left w-100">
            <b-nav-item :class="[this.$route.path == '/topics' ? 'active-nav-item' : '', isRTL ? '' : 'pl-lg-4']" to="/topics">{{
              $_t('KW:topics')
            }}</b-nav-item>

            <b-nav-item class="d-md-none" :class="this.$route.path.includes('/magidei-shiur') ? 'active-nav-item' : ''" to="/magidei-shiur">{{
              $_t('KW:speakers')
            }}</b-nav-item>

            <b-nav-item-dropdown
              class="shas-dropdown d-none d-md-block"
              :class="this.$route.path.includes('/magidei-shiur') ? 'active-nav-item' : ''"
              :text="$_t('KW:speakers')"
              toggle-class="text-white"
              no-caret
            >
              <b-dropdown-group>
                <b-dropdown-group class="p-4 bg-light-blue w-100">
                  <b-dropdown-item class="mb-2" to="/magidei-shiur">
                    <span class="text-white">{{ $_t('KW:hadafBeiyunShiur') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item to="/magidei-shiur?type=all-magidei-shiur">
                    <span class="text-white">{{ $_t('KW:allMagideiShiur') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item to="/magidei-shiur?type=mishna-magidei-shiur">
                    <span class="text-white">{{ $_t('KW:mishnaMagideiShiur') }}</span>
                  </b-dropdown-item>
                </b-dropdown-group>
              </b-dropdown-group>
            </b-nav-item-dropdown>

            <b-nav-item class="d-md-none" :class="this.$route.path.includes('/masechtos') ? 'active-nav-item' : ''" to="/masechtos">{{
              $_t('KW:selectMasechta')
            }}</b-nav-item>
            <b-nav-item class="d-md-none" :class="this.$route.path.includes(dafLink) ? 'active-nav-item' : ''" :to="dafLink">{{
              $_t('KW:todayDaf')
            }}</b-nav-item>

            <b-nav-item-dropdown
              :class="this.$route.path.includes('/masechtos') ? 'shas-dropdown active-nav-item' : 'shas-dropdown'"
              :html="masechtaNavTitle"
              toggle-class="text-white"
              menu-class="shadow"
              class="d-none d-md-block"
              no-caret
            >
              <b-dropdown-group class="p-4 bg-light-blue w-100">
                <b-dropdown-item :to="dafLink" class="font-weight-bold mb-2">
                  <span class="text-white">
                    <i class="fa fa-calendar mr-1"></i>
                    {{ $_t('KW:todayDaf') }}
                  </span>
                </b-dropdown-item>
                <b-dropdown-item to="/masechtos" class="font-weight-bold">
                  <span class="text-white">
                    <i class="fa fa-user mr-1"></i>
                    {{ $_t('KW:selectMasechta') }}
                  </span>
                </b-dropdown-item>
              </b-dropdown-group>
            </b-nav-item-dropdown>

            <b-nav-item :class="this.$route.path.includes('/mishna') ? 'active-nav-item' : ''" to="/mishna">
              <div v-html="mishnaMasechtaNavTitle"></div>
            </b-nav-item>

            <!-- <b-nav-item v-if="!isRTL" :class="this.$route.path == '/live' ? 'active-nav-item' : ''" to="/live">{{ $_t('KW:live') }}</b-nav-item> -->

            <b-nav-item :class="this.$route.path == '/podcasts' ? 'active-nav-item' : ''" to="/podcasts">{{ $_t('KW:podcasts') }}</b-nav-item>

            <b-nav-item-dropdown
              class="shas-dropdown d-none d-md-block"
              :class="this.$route.path.includes('/magidei-shiur') ? 'active-nav-item' : ''"
              :text="$_t('KW:more')"
              toggle-class="text-white"
              no-caret
            >
              <b-dropdown-group>
                <b-dropdown-group class="p-4 bg-light-blue w-100">
                  <b-dropdown-item class="mb-2" to="/haskamos">
                    <span class="text-white">{{ $_t('KW:haskamos') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item class="mb-2" to="/contact-us">
                    <span class="text-white">{{ $_t('KW:contact') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item class="mb-2" to="/about-shas-illuminated">
                    <span class="text-white">{{ $_t('KW:site.aboutUs') }}</span>
                  </b-dropdown-item>
                </b-dropdown-group>
              </b-dropdown-group>
            </b-nav-item-dropdown>

            <b-nav-item v-if="isRTL" href="http://shasilluminated.org/">
              Shas <br />
              Illuminated
            </b-nav-item>
            <b-nav-item v-else href="https://hadafbeiyun.org/">עִברִית</b-nav-item>

            <b-nav-item :class="this.$route.path == '/daf-resources' ? 'active-nav-item' : ''" class="right-menu-item right-outline" to="/daf-resources">{{
              $_t('KW:torahResources')
            }}</b-nav-item>

            <b-nav-item class="donate-btn" href="https://www.charidy.com/shasilluminated2024">
              <i class="fa fa-plus pr-1"></i> {{ $_t('KW:donate') }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
  </div>
</template>
<script>
import PlayerComponent from './Player/Index.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    Player: PlayerComponent,
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'header',
  },
  computed: {
    masechtaNavTitle() {
      let subtitle = '<span>' + this.$_t('KW:site.subtitle') + '</span>';
      if (this.isRTL) {
        return this.$_t('KW:site.title');
      } else {
        return this.$_t('KW:site.title') + '<br />' + subtitle;
      }
    },
    mishnaMasechtaNavTitle() {
      let subtitle = '<span>' + this.$_t('KW:site.subtitle') + '</span>';
      return this.$_t('KW:site.title_mishna') + '<br />' + subtitle;
    },
    ...mapGetters({ daf: 'api/daf' }),
    dafLink() {
      if (!this.daf || !this.daf.masechta) return;
      return '/shiur/masechta-' + this.daf.masechta.url_key + '/daf-' + this.daf.daf;
    },
  },
  data: function () {
    return {
      showCollapse: false,
    };
  },
  watch: {
    $route: function () {
      this.showCollapse = false;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  padding-top: 80px;
  @media (max-width: 992px) {
    padding-top: 15px;
  }
  .navbar-nav {
    @media (max-width: 992px) {
      height: unset;
      border-radius: 10px !important;
      background: none !important;
    }

    .nav-item {
      flex-grow: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      &:not(:last-child):hover {
        background-color: $light-blue;
        @media (max-width: 992px) {
          background-color: inherit;
        }
      }

      a {
        color: $white;
        font-size: 1rem;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &:hover {
          color: $white;
        }
        &:focus {
          color: unset;
        }
        @media (max-width: 992px) {
          color: $dark-blue;
          font-size: 1.25rem !important;
          margin-bottom: 7px;
          &:hover,
          &:focus {
            color: $dark-blue !important;
          }
        }
      }
    }

    .right-menu-item {
      flex-grow: 0.3;

      a {
        color: $light-gray;
        font-weight: 400;
        font-size: 0.85rem;
        @media (max-width: 992px) {
          color: $dark-blue;
        }
      }
    }

    .nav-item:first-child {
      border-radius: 100px 0 0 100px;
    }

    .nav-item.active-nav-item {
      a {
        border-bottom: 3px solid $secondary;
      }
      color: $white;
      @media (max-width: 992px) {
        padding: 0 20px;
      }
      // border-bottom: 5px solid $secondary;
    }
    .nav-item.active-nav-item.right-menu-item {
      // border-bottom: unset;
    }

    .nav-item.b-nav-dropdown {
      span::after {
        display: none;
      }
    }

    .donate-btn {
      background: $secondary;
      height: 100%;
      border-radius: 0 100px 100px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: -1px; // remove the slightly blue outline on btn right
      a {
        color: $dark-blue;
        flex-direction: row;
        &:hover {
          color: $dark-blue;
        }
      }
      @media (max-width: 992px) {
        margin-top: 10px;
        padding: 0 20px;
        border-radius: 100px;
        a {
          color: $white;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.nav-item.b-nav-dropdown {
  a {
    &:active,
    &:focus {
      border: none;
      outline: none;
    }
    @media (max-width: 992px) {
      span {
        color: $dark-blue;
      }
    }
  }
  .nav-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover,
    &:focus {
      color: $white;
    }
  }
  .dropdown-toggle::after {
    display: none;
  }
}
#logo-md {
  height: 140px;
  @media (max-width: 992px) {
    height: 200px;
  }
}
</style>
<style>
.dropdown:hover > .dropdown-menu {
  display: block;
}

.shas-dropdown .dropdown-menu {
  margin: 0;
  border: 0;
  padding: 0;
  min-width: 100%;
  font-size: 1rem;
}

.shas-dropdown .dropdown-menu .dropdown-item:hover,
.dropdown-item:focus li a {
  background-color: unset !important;
  font-weight: 600;
}
</style>
